import {Component, OnInit} from '@angular/core';
import {ApiService} from '../service/api.service';

@Component({
  selector: 'app-successful',
  templateUrl: './successful.component.html',
  styleUrls: ['./successful.component.scss']
})
export class SuccessfulComponent implements OnInit {

  constructor(public apiService: ApiService) {
  }

  ngOnInit() {
  }

}
